import axios from 'axios'
import { cohUrl, getHeader } from '@/config'

const state = {
  typeList: []
}

const mutations = {
  SET_COH_TYPE_LIST (state, obj) {
    state.typeList = obj
  }
}

const actions = {
  getCashOnHandTypeList: ({ commit }) => {
    axios.get(cohUrl + '/type', { headers: getHeader() })
      .then(response => {
        commit('SET_COH_TYPE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
